import { Languages } from '@/translations/languages';
import { atom } from 'jotai';

type WidgetLanguageState = {
  widgetLanguage: Languages;
};

export const widgetLanguageAtom = atom<WidgetLanguageState>({
  widgetLanguage: Languages.en
});
